const RELATIVE_PATH = /^\/[^/\\]/;
const FORBIDDEN_SUBSTRING = /[\\:]|\/\//;
// Control characters that would allow header injection if the value were used
// in a Location: header. Covers literal CR/LF/NUL and their percent-encoded forms.
const CONTROL_CHARS = /[\r\n\0]|%0[adAD]|%00/;

/**
 * Validates that an input is a same-origin relative path safe for both
 * client-side router navigation (Clerk SDK redirect props, React Router's
 * navigate()) and server-side Location: header values.
 *
 * Rejects:
 *  - protocol-relative URLs (starts with //)
 *  - absolute URLs and javascript: schemes
 *  - embedded // or backslashes
 *  - overlong inputs (> 200 chars)
 *  - control characters: CR (\r), LF (\n), NUL (\0) and their percent-encoded
 *    equivalents (%0d, %0a, %00) that could enable HTTP header injection
 */
export function safeRedirect(
  input: string | null | undefined,
  fallback = "/"
): string {
  if (!input) return fallback;
  if (input.length > 200) return fallback;
  if (input === "/") return "/";
  if (!RELATIVE_PATH.test(input)) return fallback;
  if (FORBIDDEN_SUBSTRING.test(input)) return fallback;
  if (CONTROL_CHARS.test(input)) return fallback;
  return input;
}
